import { useEffect, useState } from 'react'
import styles from './style.module.css'
import Interviews from '../Interviews'

export default function FeedbackWidget() {
    const [visible, setVisible] = useState(false)
    const showWidget = sessionStorage.getItem('hideWidget')

    useEffect(() => {
        if (!showWidget) {
            setTimeout(() => {
                setVisible(true)
            }, 3000)
        }
    }, [])

    function onClose() {
        setVisible(false)
        sessionStorage.setItem('hideWidget', 'true')
    }

    return (
        <div className={`${styles.container} ${visible ? styles.visible : ''}`}>
            <Interviews onClose={onClose} />
        </div>
    )
}